import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button, Col, Row } from 'reactstrap';
import WizardLayout from './WizardLayout';
import { Wizard } from 'react-use-wizard';
import StepAnimated from './StepAnimated';

export const IntakeComplete = () => {
  const navigate = useNavigate();
  const { clinicUniqueId } = useParams()
  const [searchParams] = useSearchParams()

  const [internalRef, setInternalRef] = useState()

  useEffect(() => {
    setInternalRef(searchParams.get('internalRef'))
  }, [searchParams])

  const onNewIntake = (e) => {
    navigate(`/${(clinicUniqueId ?? '')}`)
  }

  const [activeStep, setActiveStep] = useState(0)
  const bodyRef = React.useRef(React.createRef());

  const context = useMemo(() => {
    return {
      activeStep,
      setActiveStep,
      disableNavigation: false,
    }
  }, [activeStep, setActiveStep])

  return (
    <WizardLayout context={context}>
      <Wizard.Header>Insurance Verification Request Submitted</Wizard.Header>
      <Wizard.Body bodyRef={bodyRef}>
        <Wizard>
          <StepAnimated bodyRef={bodyRef}>
            <Row>
              <Col xs={{ size: 12 }} md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }} className='text-center d-flex flex-column justify-content-center'>
                <h4>Thank You!</h4>
                <p>The Insurance Verification Request was successfully submitted, and the team will start working on it shortly. The Insurance Verification Request internal ID is "{internalRef}".</p>

                <p>If you have any questions, please don't hesitate to reach out to us.</p>

                <p>Have an awesome day!</p>
                <Button color="primary" className="m-4 p-4"
                  onClick={onNewIntake}
                    >
                    New Request
                </Button>
              </Col>
            </Row>
          </StepAnimated>
          </Wizard>
      </Wizard.Body>
    </WizardLayout>
  )
}
